import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import CustomhtmlForFeature from 'utils/CustomDefault';

export const INCOME_LAYER_ID = 'incomeLayer';

const layerConfig = {
  title: 'Income',
};

function IncomeLayer() {
  const dispatch = useDispatch();
  const { incomeLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) => selectSourceById(state, incomeLayer?.source));
  const cartoLayerProps = useCartoLayerProps({ source });

  if (incomeLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: INCOME_LAYER_ID,

      stroked: false,
      filled: true,
      getFillColor: colorBins({
        attr: 'Median_Household_Income',
        domain: [35000, 50000, 65000, 80000, 100000],
        colors: [
          [235, 250, 235],
          [181, 240, 181],
          [123, 235, 123],
          [15, 213, 16],
          [8, 158, 5],
          [0, 100, 0],
        ],
      }),
      pointRadiusMinPixels: 3.5,

      pickable: true,
      visible: incomeLayer.visible,
      opacity: incomeLayer.opacity,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: INCOME_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: CustomhtmlForFeature({
              feature: info.object,
              title: 'Income Details',
              includeColumns: [
                'Block_Group_Identifier',
                'Total_Population',
                'Median_Household_Income',
                'Poverty_Percentage',
                'Low_To_Moderate_Income_Persons_Percentage',
                'Unemployment_Rate_Percentage',
              ],
            }),
          };
        }
      },
    });
  }
}

export default IncomeLayer;
